"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacesOutsideParentheses = / (?=([^()]*\([^()]*\))*[^()]*$)/g;
exports.unsafeClassNameCharacters = /[^_a-zA-Z0-9-]/g;
//# sourceMappingURL=regex.js.map